import CustomCheckBox from "@/components/CustomCheckBox/CustomCheckBox.vue";

export default {
    name: 'RequiredOne',
    components: {
        CustomCheckBox
    },
    data() {
        return {}
    },
    props: {
        prefixInput: String,
        item: Object,
    },
    methods: {
        clickCheck(payload) {
            this.$props.item.check.requiredOne = payload
        },
    }
}